import Lottie from 'lottie-react';
import loaderAnimation from '@/assets/loader-animation.json';
import { cn } from '@/lib/utils';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'w-12 h-12',
  md: 'w-16 h-16',
  lg: 'w-24 h-24',
};

export const Loader = ({ size = 'md', className }: LoaderProps) => {
  return (
    <div className={cn(sizeMap[size], className)}>
      <Lottie animationData={loaderAnimation} loop={true} />
    </div>
  );
};
